import { SearchResult } from '@/app/(main)/_components/search-modal/search-modal.types';
import { isVaccineSearch } from '@/store/search/search.store';

export const isVaccineSearchMode = (selectedSearchState?: SearchResult): boolean => {
  return selectedSearchState ? isVaccineSearch() : false;
};
